export function toggleFilterCover() {
    document.querySelector("main").classList.toggle("filter-cover")
}
